const state = {
  infoContrato: {
    contrato_id: '',
    tipo_imovel_servico_id: '',
    nome: '',
    tipo_contrato_id: '',
    tipo_imovel_contrato_id: ''
  }
}

const mutations = {
  setInfoContrato (state, obj) {
    state.infoContrato = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/infoContrato.js